// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4044":"d7effc80","8855":"8040c38b"}[chunkId] + ".chunk.css";
};